import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { API_UPDATE_USER_PROFILE } from "../../../config/api";
import { closeModal, showErrorModal } from "../../reducers/messageSlice";
import { fetchUserProfile } from "./getProfile";
import { proccessErrorMessage } from "../../../helper/proccessErrorMessage";
import mixpanel from "mixpanel-browser";
import { toast } from "react-toastify";

export const updateUserProfile = createAsyncThunk(
  "userProfile/update",
  async (payload, { dispatch, getState }) => {
    const { profile, user } = getState().onboarding;
    const { userBanks } = getState().bank;
    try {
      const { data } = await Client({
        method: "POST",
        path: API_UPDATE_USER_PROFILE,
        data: payload.data,
        contentType: "multipart/form-data",
        serializerConfig: { indexes: null },
      });

      dispatch(fetchUserProfile());
      toast.success("Profile updated successfully.");
      payload?.cb();

      if (
        user?.hasSetPin &&
        userBanks?.length > 1 &&
        (!profile?.nok_email || !profile?.gender)
      ) {
        mixpanel.track("WEB-Onboarded", {
          type: "Onboarding",
        });
      }
      // mixpanel.track("Success", {
      //   type: "Profile",
      //   subtype: "update-profile",
      // });

      return { ...payload.formValues };
    } catch (error) {
      const msg = proccessErrorMessage(error);

      // mixpanel.track("Error", {
      //   type: "Profile",
      //   subtype: "update-profile",
      //   message: msg,
      // });

      // dispatch(showErrorModal(msg || "An error has occurred"));
      toast.error(msg);
      payload.setSubmitting(false);
    }
  }
);
